import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import {
  ListBox,
  ListBoxToolbar,
  processListBoxData,
  ListBoxToolbarClickEvent,
  ListBoxItemClickEvent,
} from "@progress/kendo-react-listbox";

import AddColumnDialog from "./AddColumnDialog";



type handler = () => void;
interface settingsProps {
  visible: boolean;
  toggleVisible: handler;
    columnsHandler: any;
    usedColumns: any[];
    unUsedColumns: any[];
    addColumn: any;
    loadingHeader: any;
}

/////////////////////////////////////////////////////////////////////////


const SELECTED_FIELD = 'selected';


//////////////////////////////////////////////////////////////////////////


const ManageColumnDialog = (props: settingsProps) => {

    const [state, setState] = React.useState({
        selectedColumns: props.usedColumns,
        unSelectedColumns: props.unUsedColumns
    });

    const handleItemClick = (event, data, connectedData) => {
       // console.log(event,data,connectedData)
        setState({
            ...state,
            [data]: state[data].map(item => {
                if (item.title=== event.dataItem.title) {
                    item[SELECTED_FIELD] = !item[SELECTED_FIELD];
                } else if (!event.nativeEvent.ctrlKey) {
                    item[SELECTED_FIELD] = false;
                }
                return item;
            }),
            [connectedData]: state[connectedData].map(item => {
                item[SELECTED_FIELD] = false;
                return item;
            })
        });
    };
    const handleToolBarClick = e => {
        let toolName = e.toolName || '';
        let result = processListBoxData(state.selectedColumns, state.unSelectedColumns, toolName, SELECTED_FIELD);
        setState({
            ...state,
            selectedColumns: result.listBoxOneData,
            unSelectedColumns: result.listBoxTwoData
        });
    };



    const updateColumns = () => {
        props.columnsHandler(state.selectedColumns,state.unSelectedColumns)
    };
    const renderUpdateButton = () => {
        return (
            <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                onClick={() => updateColumns()}
            >
                Update Columns
            </button>
        );
    }
    const renderListBoxContent = () => {
       // console.log(state,props)
        return <div className="container">
            <div className="row justify-content-center">
                <div className="col k-pr-2">
                    <h6>Show Columns</h6>
                    <ListBox style={{
                        height: 400,
                        width: '100%'
                    }} data={state.selectedColumns} textField="title" selectedField={SELECTED_FIELD} onItemClick={e => handleItemClick(e, 'selectedColumns', 'unSelectedColumns')} toolbar={() => {
                        return <ListBoxToolbar tools={['moveUp', 'moveDown', 'transferTo', 'transferFrom', 'transferAllTo', 'transferAllFrom',]} data={state.selectedColumns} dataConnected={state.unSelectedColumns} onToolClick={handleToolBarClick} />;
                    }} />
                </div>
                <div className="col k-pl-0">
                    <h6>Hide Columns</h6>
                    <ListBox style={{
                        height: 400,
                        width: '100%'
                    }} data={state.unSelectedColumns} textField="title" selectedField={SELECTED_FIELD} onItemClick={e => handleItemClick(e, 'unSelectedColumns', 'selectedColumns')} />
                </div>
            </div>
        </div>;
    }
    const renderContent = () => {
        if (props.loadingHeader) {
            return (
                <div>Adding new column.....</div>
            )
        }
        return (
            <>
                <AddColumnDialog addColumn={props.addColumn }/>
                {renderListBoxContent()}

            </>
        )
    }
    const closeDialog = () => {
        setState({
            selectedColumns: props.usedColumns,
            unSelectedColumns: props.unUsedColumns
        })
        props.toggleVisible();
    }

  const renderDialog = () => {
    if (props.visible) {
      return (
        <Dialog
          title={"Manage columns to be shown in grid"}
          onClose={closeDialog}
          width={1000}
        >
          <div>{renderContent()}</div>
          <DialogActionsBar>
            <button
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                      onClick={closeDialog}
            >
              Cancel
                  </button>
                  {renderUpdateButton()}
          </DialogActionsBar>
        </Dialog>
      );
    }
    return null;
  };
  return renderDialog();
};

export default ManageColumnDialog;
